module.exports = __webpack_public_path__ + "static/media/一阳指@2x.469493f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/一阳指@2x.png
// module id = 1528
// module chunks = 0